import React, { useLayoutEffect, useState } from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import Carousel from 'components/Carousel';
import { CarouselImagesProps } from 'types/CarouselImagesProps';
import * as S from './styles';

interface BannersColsProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function BannersCols({ data, phoneWidth }: BannersColsProps) {
  return (
    <S.container>
      {data?.items[0]?.file?.url ? (
        data.items.map(item => (
          <S.itemImg style={{ width: `${item.width || 100}%` }}>
            <img key={item.id} src={item.file?.url} alt={item.name} />
            <p>{item.name || 'No name'}</p>
          </S.itemImg>
        ))
      ) : (
        <p>No image</p>
      )}
    </S.container>
  );
}
